import Pin from '@/types/FilterTree/Pin';

/** Type filtre */
class FilterT {
    Id: string = '-1';
    Name: string;
    Pins: Pin[];
    Color: string;
    Remark: string;
    KeepAncestors: boolean;
}

export default FilterT;